import React from "react";

import { useTranslation } from "react-i18next";

import useStyles from "./styles";

interface Props {
  value: string | number;
  title?: string;
}

const ProgressBar = (props: Props) => {
  const { t: translate } = useTranslation();
  const { value, title } = props;
  const classes = useStyles({ value });

  return (
    <div className={classes.progressBar}>
      <div className={classes.progress}></div>
      <div className={classes.wrapperSummary}>
        <div className={classes.text}>{translate("documentsUploaded")}</div>
        <div className={classes.summary}>{title}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
